import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

const Event = lazy(() => import('@/pages/event'));
const QrList = lazy(() => import('@/pages/event/qr/QrList'));
const QrDetail = lazy(() => import('@/pages/event/qr/QrDetail'));

// 이벤트 관리 라우트
export const eventRoutes: TypedRouteObject = {
	path: ROOTS.EVENT,
	element: withSuspense(Event),
	handle: {
		title: '이벤트 현황',
		subTitle: 'QR 이벤트 관리 현황',
	},
	children: [
		{
			index: true,
			element: <Navigate to={paths.event.qr.list.path} replace />,
		},
		// QR 발급
		{
			path: paths.event.qr.list.path,
			element: withSuspense(QrList),
			handle: {
				title: '이벤트 현황',
				subTitle: 'QR 이벤트 관리 현황',
			},
		},
		{
			path: paths.event.qr.detail.path,
			element: withSuspense(QrDetail),
			handle: {
				isGoBack: true,
				title: '이벤트 현황',
				subTitle: '이벤트 > 발급 현황 > 상세 정보',
			},
		},
	],
};
